export default __webpack_public_path__ + "static/media/rounded-n-star.3a57fe5a.svg";